import { render, staticRenderFns } from "./FormType4.vue?vue&type=template&id=7c441cca&"
import script from "./FormType4.vue?vue&type=script&lang=js&"
export * from "./FormType4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports